export const GET_ERRORS = 'GET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const GET_USER_INFO_SUCCESS = 'GET_USER_INFO_SUCCESS';
export const GET_USER_INFO = 'GET_USER_INFO';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_CURRENT_ADMIN = 'SET_CURRENT_ADMIN';
export const GET_PROFILE = 'GET_PROFILE';
export const PROFILE_LOADING = 'PROFILE_LOADING';
export const PROFILE_NOT_FOUND = 'PROFILE_NOT_FOUND';
export const CLEAR_CURRENT_PROFILE = 'CLEAR_CURRENT_PROFILE';
export const GET_PROFILES = 'GET_PROFILES';
export const POST_LOADING = 'POST_LOADING';
export const GET_POSTS = 'GET_POSTS';
export const GET_POST = 'GET_POST';
export const ADD_PROFILE = 'ADD_PROFILE';
export const DELETE_PROFILE = 'DELETE_PROFILE';
export const WORD_LOADING = 'WORD_LOADING';
export const GET_WORDS = 'GET_WORDS';
export const GET_WORD = 'GET_WORD';
export const ADD_WORD = 'ADD_WORD';
export const DELETE_WORD = 'DELETE_WORD';
export const DIALOGUE_LOADING = 'DIALOGUE_LOADING';
export const GET_DIALOGUES = 'GET_DIALOGUES';
export const GET_DIALOGUE = 'GET_DIALOGUE';
export const ADD_DIALOGUE = 'ADD_DIALOGUE';
export const DELETE_DIALOGUE = 'DELETE_DIALOGUE';
export const ADD_POST = 'ADD_POST';
export const DELETE_POST = 'DELETE_POST';

export const GET_TUTORIALS = 'GET_TUTORIALS';
export const LOADING_TUTORIALS = 'LOADING_TUTORIALS';
export const GET_USER_INFO_LOADING = 'GET_USER_INFO_LOADING';
export const USER_LOGOUT = "USER_LOGOUT";

export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const GET_ALL_USER_SUCCESS = 'GET_ALL_USER_SUCCESS';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';

export const GET_TEACHER = 'GET_TEACHER';
export const LOADING_TEACHER = 'LOADING_TEACHER';
export const GET_TOP_STUDENT = 'GET_TOP_STUDENT';
export const LOADING_TOP_STUDENT = 'LOADING_TOP_STUDENT';
export const GET_STUDENT_TESTIMONIAL = 'GET_STUDENT_TESTIMONIAL';
export const LOADING_STUDENT_TESTIMONIAL = 'LOADING_STUDENT_TESTIMONIAL';
export const GET_NEWS = 'GET_NEWS';
export const LOADING_NEWS = 'LOADING_NEWS';
export const RANDOM_WORD = 'RANDOM_WORD';
export const USER_CHANGE_PASSWORD_SUCCESS = 'USER_CHANGE_PASSWORD_SUCCESS';
export const USER_RESET_PASSWORD_SUCCESS = 'USER_RESET_PASSWORD_SUCCESS';
export const USER_RESET = 'USER_RESET';

export const GET_QUESTIONS = 'GET_QUESTIONS';
export const GET_QUESTION = 'GET_QUESTION';
export const ADD_QUESTION = 'ADD_QUESTION';
export const DELETE_QUESTION = 'DELETE_QUESTION';
export const EDIT_QUESTION = 'EDIT_QUESTION';
export const QUESTION_LOADING = 'QUESTION_LOADING';
export const QUESTION_BANK = 'QUESTION_BANK';

export const RESET_EXAM = 'RESET_EXAM';
export const START_EXAM = 'START_EXAM';
export const START_CHALLENGE = 'START_CHALLENGE';
export const SAVE_EXAM = 'SAVE_EXAM';
export const LIST_EXAM = 'LIST_EXAM';
export const REMOVE_EXAM = 'REMOVE_EXAM';
export const VIEW_EXAM = 'VIEW_EXAM';
export const EXAM_LOADING = 'EXAM_LOADING';

export const ADD_ADVISION = 'ADD_ADVISION';